<template>
    
<v-dialog
    v-model="showPaperworkByOrder"
    hide-overlay
    persistent
    max-width="400px"
    transition="dialog-bottom-transition"
    >
    <v-card>
        <v-card-title>
            <p style="margin: 0 auto;">Order Paperwork</p>
        </v-card-title>

        <v-simple-table>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-center">
                            Document Type
                        </th>
                        <th class="text-center">
                            Link
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="doc in paperworkData"
                        :key="doc.DocumentID"
                    >
                        <td class="text-center">
                            {{ doc.DocumentType }}
                        </td>
                        <td class="text-center">
                            <a :href="doc.Link" target="_blank"
                                >Show document</a
                            >
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                text
                @click="$emit('close')"
            >
                Close
            </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>
<script>
export default {
    props:['showPaperworkByOrder','paperworkData'],
    data: function(){
        return {
        }
    }
}
</script>